import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Grid, Card, CardContent, Typography, CardActions, Button, Alert } from '@mui/material';
import { apiFetch } from '../services/api';

function ReportsPage() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await apiFetch('/api/v1/reports');
        if (!response.ok) throw new Error('Errore nel recupero dei report');
        const data = await response.json();
        setItems(data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchItems();
  }, []);

  if (error) return <Alert severity="error">{error}</Alert>;

  return (
    <Box sx={{ flexGrow: 1, padding: 4 }}>
      <Grid container spacing={2}>
        {items.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <Card sx={{ maxWidth: 345, margin: 2 }}>
              <CardContent>
                <Typography variant="h5" component="div" style={{ textTransform: 'uppercase' }}>
                  {item.name}
                </Typography>
              </CardContent>
              <CardActions>
                <Button component={Link} to={`/report/${item.id}`}>Scopri di più</Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default ReportsPage;
